module.exports = __webpack_public_path__ + "static/media/Portrait-10256.6442151f.jpg";